import { helper } from './helper';

export const name = helper.accessor('Name', { header: '名称' });
